
export const loadUserMe = ( data ) => {
    return { type: "USERS:LOAD_ME", data }
}

export const loadLanguages = ( data ) => {
    return { type: "USERS:LOAD_LANGUAGES", data }
}
